module.exports = __webpack_public_path__ + "media/dorobek/assets/images/exclamation-mark-red-ea1d76a68ffa0e2f6ba9d79764a77374.svg";